module.exports = __webpack_public_path__ + "static/hero-paper-left-31d2b12f635c0d69d80aabca0b865ea2.webp";